// Реферальная программа (решение владельца 2026-10-09): друг засчитан после REFERRAL_MATCHES публичных матчей.

export const REFERRAL = {
  /** сколько публичных матчей (турнир или 1 на 1) должен сыграть приглашённый */
  matches: 3,
  inviter: { tickets: 1, coins: 300 },
  invitee: { tickets: 1, coins: 200 },
  /** рубежи: столько засчитанных друзей — предмет, который не продаётся */
  milestones: [
    { count: 3, itemId: 'frame-recruiter' },
    { count: 10, itemId: 'ball-legend' },
  ],
} as const;

export interface ReferralFriendDto {
  name: string;
  kit: string;
  /** сыграно публичных матчей (до REFERRAL.matches) */
  matches: number;
  qualified: boolean;
}

/** GET /api/referrals */
export interface ReferralsDto {
  /** личная ссылка «играть» */
  link: string;
  friends: ReferralFriendDto[];
  qualified: number;
  /** получено за приглашения */
  earned: { tickets: number; coins: number };
  milestones: { count: number; itemId: string; reached: boolean }[];
}
